import { alert, format_date, toFixed, total, GET } from "./CustomComponent.js";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ThaiBahtText from "thai-baht-text";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: {
    normal: "FCIconic-Light.ttf",
    bold: "FCIconic-Bold.ttf",
    italics: "FCIconic-Italic.ttf",
    bolditalics: "FCIconic-Italic.ttf",
  },
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

function formatReceiptTaxItemLine(item, isRepair) {
  return (
    [item.product_code, item.product_name, item.remark, isRepair ? null : item.document_no]
      .filter((v) => v != null && String(v).trim() !== "")
      .join(" ") || " "
  );
}

function repairReceiptFields(repair) {
  const amount = Number(repair?.amount || 0);
  const vat =
    repair?.vat != null && repair?.vat !== ""
      ? Number(repair.vat)
      : repair?.is_vat
      ? amount * 0.07
      : 0;
  return {
    amount,
    amount_deposit: Number(repair?.amount_deposit || 0),
    total_pay: Number(repair?.total_pay || 0),
    is_vat: repair?.is_vat,
    vat,
    transaction_list: [
      ...(repair?.stock_activity_list || [])
        .map((e) => e.transaction_list || [])
        .flat(),
      ...(repair?.transaction_list || []),
    ],
  };
}

function value(text = " ", width = 300, alignment = "center") {
  return {
    width: width,
    stack: [
      {
        text: text || " ",
        fontSize: 16,
        alignment: alignment,
        margin: [12, 0, 12, 0],
      },
      {
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: width,
            y2: 0,
            lineWidth: 1,
            dash: { length: 2 },
          },
        ],
        margin: [0, -6, 0, 0]
      },
    ],
  };
}
function checkbox(checked, size = 12) {
  return checked
    ? {
        canvas: [
          // กล่องดำ
          {
            type: "rect",
            x: 0,
            y: 0,
            w: size,
            h: size,
            color: "black",
          },
          // เช็คถูก
          {
            type: "polyline",
            lineWidth: 2,
            lineColor: "white",
            points: [
              { x: size * 0.2, y: size * 0.55 },
              { x: size * 0.45, y: size * 0.75 },
              { x: size * 0.8, y: size * 0.25 },
            ],
          },
        ],
        width: size + 10,
        height: size,
        margin: [3, 4, 2, 4],
      }
    : {
        canvas: [
          {
            type: "rect",
            x: 0,
            y: 0,
            w: size,
            h: size,
            lineWidth: 1,
          },
        ],
        width: size + 10,
        height: size,
        margin: [3, 4, 2, 4],
      };
}

async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}
async function open(docDefinition) {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download("ทดสอบ");
    if (error === "Open PDF in new window blocked by browser") {
      alert(
        "warning",
        "แจ้งเตือน",
        "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์"
      );
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}

// ใบเสนอราคา
async function report_quotation(uid) {
  let data = {};
  let result = await GET("admin/sales/list", { uid });
  if (result?.status) {
    const item = result.data;
    data = {
      document_no: item.document_no,
      created_at: item.created_at,
      customer_name: item.customer?.full_name,
      customer_phone: item.customer?.phone,
      transaction_list: item.transaction_list || [],
      amount: item.amount,
      amount_deposit: item.amount_deposit,
      discount: item.discount,
      total_pay: item.total_pay,
      warehouse: item.warehouse?.name || "",
      is_delivery: item.is_delivery,
      ref_number: item.ref_number,
    };
  }
  let _total = 0;
  const array = data.transaction_list.map((item) => {
    _total += item.qty * item.unit_price;
    return [
      {
        text: `${item.product_name} ${item.remark ? `(${item.remark})` : ""}`,
        fontSize: 18,
        bold: true,
      },
      {
        text: `${
          item.serial_number.length !== 0
            ? `No. ${item.serial_number.toString()}`
            : ""
        }`,
        fontSize: 18,
        bold: true,
      },
      {
        columns: [
          {
            text: `${item.qty} x ${toFixed(item.unit_price)}`,
            alignment: "left",
            fontSize: 18,
            width: "50%",
            bold: true,
          },
          {
            text: `${toFixed(item.qty * item.unit_price)} ฿`,
            alignment: "right",
            fontSize: 18,
            width: "50%",
            bold: true,
          },
        ],
      },
    ];
  });
  const delivery = data.is_delivery
    ? { text: `ส่งปลายทาง`, fontSize: 16, alignment: "left", bold: true }
    : { text: ``, fontSize: 1 };
  const body = JSON.stringify([
    {
      text: `ใบเสนอราคา(${data.warehouse})`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 14,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        {
          text: `เลขที่ : ${data.document_no}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
        {
          text: `วันที่ : ${format_date(data.created_at, "dd mmmm yyyy")}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
      ],
    },
    {
      columns: [
        {
          text: `ลูกค้า : ${data.customer_name}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
        {
          text: `โทร : ${data.customer_phone}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
      ],
    },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    { text: ` `, fontSize: 10 },
    ...array,
    { text: ` `, fontSize: 10 },
    {
      text: data.ref_number ? `เลขที่อ้างอิง : ${data.ref_number}` : "",
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    { text: ` `, fontSize: 10 },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    {
      columns: [
        {
          text: `รวมทั้งหมด (จำนวนรวม ${total(data.transaction_list, "qty")} )`,
          alignment: "left",
          fontSize: 18,
          width: "70%",
          bold: true,
        },
        {
          text: `${toFixed(_total)} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "30%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ส่วนลด`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(
            Number(data.discount) + total(data.transaction_list, "discount")
          )} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `หัก มัดจำ`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(data.amount_deposit)} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `รวมเป็นเงินทั้งหมด`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(
            Number(data.amount) -
              Number(data.amount_deposit) -
              Number(data.discount)
          )} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      text: `*ราคานี้ไม่รวมภาษีมูลค่าเพิ่ม`,
      fontSize: 16,
      alignment: "left",
      bold: true,
    },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    delivery,
    {
      text: [
        `สินค้าทุกชนิดที่เสนอไปแล้วหากใช้ไม่ได้หรือไม่ตรงรุ่น นำ มาเปลี่ยน ภายใน 5 วัน เท่านั้น แต่ถ้าสินค้าไม่มีต้องรอ สั่งให้`,
        {
          text: ` ไม่รับคืนเด็ดขาด `,
          fontSize: 18,
          alignment: "left",
          bold: true,
        },
        `นอกจากมีข้อตกลงเป็นลายลักษณ์ อักษรเท่านั้น ถ้ามีการซื้อจะต้องเสียภาษีมูลค่าเพิ่ม`,
      ],
      fontSize: 18,
      textWrap: true,
    },
  ]);

  var docDefinition = {
    pageSize: {
      width: 302,
      height: "auto",
    },

    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [15, 15, 15, 15],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบมัดจำสินค้า
async function report_deposit(uid) {
  let data = {};
  let result = await GET("admin/sales/list", { uid });
  if (result?.status) {
    const item = result.data;
    data = {
      document_no: item.document_no,
      created_at: item.created_at,
      customer_name: item.customer?.full_name,
      customer_phone: item.customer?.phone,
      transaction_list: item.transaction_list || [],
      amount: item.amount,
      amount_deposit: item.amount_deposit,
      discount: item.discount,
      total_pay: item.total_pay,
      warehouse: item.warehouse?.name || "",
      is_delivery: item.is_delivery,
    };
  }
  let _total = 0;
  const array = data.transaction_list.map((item) => {
    _total += item.qty * item.unit_price;
    return [
      {
        text: `${item.product_name} ${item.remark ? `(${item.remark})` : ""}`,
        fontSize: 18,
        bold: true,
      },
      {
        text: `${
          item.serial_number.length !== 0
            ? `No. ${item.serial_number.toString()}`
            : ""
        }`,
        fontSize: 18,
        bold: true,
      },
      {
        columns: [
          {
            text: `${item.qty} x ${toFixed(item.unit_price)}`,
            alignment: "left",
            fontSize: 18,
            width: "50%",
            bold: true,
          },
          {
            text: `${toFixed(item.qty * item.unit_price)} ฿`,
            alignment: "right",
            fontSize: 18,
            width: "50%",
            bold: true,
          },
        ],
      },
    ];
  });
  const delivery = data.is_delivery
    ? { text: `ส่งปลายทาง`, fontSize: 16, alignment: "left", bold: true }
    : { text: ``, fontSize: 1 };
  const body = JSON.stringify([
    {
      text: `ใบมัดจำสินค้า(${data.warehouse})`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 14,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        {
          text: `เลขที่ : ${data.document_no}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
        {
          text: `วันที่ : ${format_date(data.created_at, "dd mmmm yyyy")}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
      ],
    },
    {
      columns: [
        {
          text: `ลูกค้า : ${data.customer_name}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
        {
          text: `โทร : ${data.customer_phone}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
      ],
    },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    { text: ` `, fontSize: 10 },
    ...array,
    { text: ` `, fontSize: 10 },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    {
      columns: [
        {
          text: `รวมทั้งหมด (จำนวนรวม ${total(data.transaction_list, "qty")} )`,
          alignment: "left",
          fontSize: 18,
          width: "70%",
          bold: true,
        },
        {
          text: `${toFixed(_total)} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "30%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ส่วนลด`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(
            Number(data.discount) + total(data.transaction_list, "discount")
          )} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `มัดจำ`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(data.amount_deposit)} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ค้างชำระ`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(
            Number(data.amount) -
              Number(data.amount_deposit) -
              Number(data.discount)
          )} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      text: `*ราคานี้ไม่รวมภาษีมูลค่าเพิ่ม`,
      fontSize: 16,
      alignment: "left",
      bold: true,
    },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    delivery,
    {
      text: "หมายเหตุ : ให้มารับสินค้าภายใน...............วัน พ้นกำหนด ถือว่าสละสิทธิ์ (สินค้าทุกชนิดมัดจำแล้วไม่รับคืน)",
      fontSize: 18,
      textWrap: true,
    },
    { text: ` `, fontSize: 10 },
    {
      text: "ลงชื่อ.....................................................ผู้มัดจำ",
      fontSize: 18,
      textWrap: true,
    },
    {
      text: "(.......................................................................)",
      fontSize: 18,
      textWrap: true,
    },
  ]);
  var docDefinition = {
    pageSize: {
      width: 302,
      height: "auto",
    },

    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [15, 15, 15, 15],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบยืมสินค้า
async function report_loan(uid) {
  let data = {};
  let result = await GET("admin/sales/list", { uid });
  if (result?.status) {
    const item = result.data;
    data = {
      document_no: item.document_no,
      created_at: item.created_at,
      customer_name: item.customer?.full_name,
      customer_phone: item.customer?.phone,
      transaction_list: item.transaction_list || [],
      amount: item.amount,
      amount_deposit: item.amount_deposit,
      discount: item.discount,
      total_pay: item.total_pay,
      warehouse: item.warehouse?.name || "",
      is_delivery: item.is_delivery,
      ref_number: item.ref_number,
    };
  }

  let _total = 0;
  const array = data.transaction_list.map((item) => {
    _total += item.qty * item.unit_price;
    return [
      {
        text: `${item.product_name} ${item.remark ? `(${item.remark})` : ""}`,
        fontSize: 18,
        bold: true,
      },
      {
        text: `${
          item.serial_number.length !== 0
            ? `No. ${item.serial_number.toString()}`
            : ""
        }`,
        fontSize: 18,
        bold: true,
      },
      {
        columns: [
          {
            text: `${item.qty} x ${toFixed(item.unit_price)}`,
            alignment: "left",
            fontSize: 18,
            width: "50%",
            bold: true,
          },
          {
            text: `${toFixed(item.qty * item.unit_price)} ฿`,
            alignment: "right",
            fontSize: 18,
            width: "50%",
            bold: true,
          },
        ],
      },
    ];
  });
  const body = JSON.stringify([
    {
      text: `ใบยืมสินค้า(${data.warehouse})`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 14,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        {
          text: `เลขที่ : ${data.document_no}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
        {
          text: `วันที่ : ${format_date(data.created_at, "dd mmmm yyyy")}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
      ],
    },
    {
      columns: [
        {
          text: `ลูกค้า : ${data.customer_name}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
        {
          text: `โทร : ${data.customer_phone}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
      ],
    },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    { text: ` `, fontSize: 10 },
    ...array,
    { text: ` `, fontSize: 10 },

    {
      text: data.ref_number ? `เลขที่อ้างอิง : ${data.ref_number}` : "",
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    { text: ` `, fontSize: 10 },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    {
      columns: [
        {
          text: `รวมทั้งหมด (จำนวนรวม ${total(data.transaction_list, "qty")} )`,
          alignment: "left",
          fontSize: 18,
          width: "70%",
          bold: true,
        },
        {
          text: `${toFixed(_total)} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "30%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ส่วนลด`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(
            Number(data.discount) + total(data.transaction_list, "discount")
          )} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `รวมเป็นเงินทั้งหมด`,
          alignment: "left",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
        {
          text: `${toFixed(
            Number(data.amount) -
              Number(data.amount_deposit) -
              Number(data.discount)
          )} ฿`,
          alignment: "right",
          fontSize: 18,
          width: "50%",
          bold: true,
        },
      ],
    },
    {
      text: `*ราคานี้ไม่รวมภาษีมูลค่าเพิ่ม`,
      fontSize: 16,
      alignment: "left",
      bold: true,
    },
    { text: ` `, fontSize: 10 },
    { text: ` `, fontSize: 10 },
    { text: ` `, fontSize: 10 },
    { text: ` `, fontSize: 10 },
  ]);
  var docDefinition = {
    pageSize: {
      width: 302,
      height: "auto",
    },

    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [15, 15, 15, 15],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// บิลเบิกอะไหล่ ซ่อม-ติดตั้ง
async function report_get_spare_parts(uid) {
  let data = {};
  let result = await GET("admin/stock-activities/list", { uid });
  if (result?.status) {
    const item = result.data;
    data = {
      document_no: item.document_no,
      repair_document_no: item.repair?.document_no || "",
      repair_car_registration: item.repair?.car_registration || "",
      repair_model: item.repair?.model || "",
      repair_cause: item.repair?.cause || item?.remark || "",
      created_at: item.created_at,
      transaction_list: item.transaction_list || [],

      warehouse_name: item.warehouse?.name || "",
      destination_warehouse_name: item.destination_warehouse?.name || "",
    };
  }
  const array = data.transaction_list.map((item) => [
    {
      columns: [
        {
          text: `${item.product_name} ${item.remark ? `(${item.remark})` : ""}`,
          alignment: "left",
          fontSize: 18,
          width: "80%",
          bold: true,
        },
        {
          text: `X${item.qty} `,
          alignment: "right",
          fontSize: 18,
          width: "20%",
          bold: true,
        },
      ],
    },
  ]);
  const body = JSON.stringify([
    {
      text: `บิลเบิกอะไหล่ ซ่อม-ติดตั้ง`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      text: `เลขที่ใบเบิก : ${data.document_no}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    {
      text: `วันที่ : ${format_date(data.created_at, "dd mmmm yyyy", "th")}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    {
      text: `เลขที่แจ้งซ่อม : ${data.repair_document_no}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    {
      text: `คลังสินค้าต้นทาง : ${data.warehouse_name}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    {
      text: `คลังสินค้าปลายทาง : ${data.destination_warehouse_name}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    { text: ` `, fontSize: 10 },
    ...array,
    { text: ` `, fontSize: 10 },
    {
      text: `-----------------------------------------------------------------------------------------------------------------------------`,
      fontSize: 10,
      alignment: "center",
    },
    {
      text: `สาเหตุ : ${data.repair_cause}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    {
      columns: [
        {
          text: `ซ่อม`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
        {
          text: `ทะเบียน : ${data.repair_car_registration} ${data.repair_model}`,
          alignment: "left",
          fontSize: 16,
          bold: true,
          width: "50%",
        },
      ],
    },
    { text: `ติดตั้ง`, alignment: "left", fontSize: 16, bold: true },
    { text: ` `, fontSize: 10 },
    {
      text: `ลงชื่อ......................................................................ผู้จ่ายของ`,
      alignment: "center",
      fontSize: 16,
      bold: true,
    },
    {
      text: `วันที่....................................................................................`,
      alignment: "center",
      fontSize: 16,
      bold: true,
    },
    {
      text: `(...........................................................................)`,
      alignment: "center",
      fontSize: 16,
      bold: true,
    },
    { text: ` `, fontSize: 10 },
    {
      text: `ลงชื่อ......................................................................ผู้รับของ`,
      alignment: "center",
      fontSize: 16,
      bold: true,
    },
    {
      text: `วันที่....................................................................................`,
      alignment: "center",
      fontSize: 16,
      bold: true,
    },
    {
      text: `(...........................................................................)`,
      alignment: "center",
      fontSize: 16,
      bold: true,
    },
  ]);
  var docDefinition = {
    pageSize: {
      width: 302,
      height: "auto",
    },

    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [15, 15, 15, 15],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบรับงาน
async function report_car_receipt(uid) {
  let data = {};
  let result = await GET("admin/repairs/list", { uid });
  if (result?.status) {
    const item = result.data;
    data = {
      document_no: item.document_no,
      created_at: item.created_at,
      customer_name: item.customer?.full_name || "",
      customer_phone: item.customer?.phone || "",
      brand: item.brand || "",
      car_registration: item.car_registration || "",
      user: item.user?.full_name || "",
      user_type: item.user?.user_type || "",
      type: item.type || "",
      model: item.model || "",
      cause: item.cause || "",
    };
  }
  const body = JSON.stringify([
    { text: `ใบรับงาน`, fontSize: 20, alignment: "center", bold: true },
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 14,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 14,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    { columns: [
      {text: "วันที่ :", width: "auto"},
      value(`${format_date(data.created_at, "dd mmmm yyyy")}`, 242, "left")
    ]},
    { columns: [
      {text: "เลขที่เอกสาร :", width: "auto"},
      value(`${data.document_no || " "}`, 207, "left")
    ]},
    { columns: [
      {text: "ชื่อลูกค้า :", width: "auto"},
      value(`${data.customer_name || " "}`, 225, "left")
    ]},
    { columns: [
      {text: "เบอร์โทร :", width: "auto"},
      value(`${data.customer_phone || " "}`, 222, "left")
    ]},
    { columns: [
      {text: "ประเภท :", width: "auto"},
      value(`${data.type || " "}`, 225, "left")
    ]},
    { columns: [
      {text: "ยี่ห้อ :", width: "auto"},
      value(`${data.brand || " "}`, 242, "left")
    ]},
    { columns: [
      {text: "ทะเบียน :", width: "auto"},
      value(`${data.car_registration + " " + data.model}`, 225, "left")
    ]},
    { columns: [
      {text: "บันทึกช่าง :", width: "auto"},
      value(" ", 218, "left")
    ]},
    value(" ", 266, "left"),
    { text: ` `, fontSize: 4 },
    value(" ", 266, "left"),
    { text: ` `, fontSize: 5 },
    value(" ", 266, "left"),
    { text: ` `, fontSize: 5 },
    value(" ", 266, "left"),
    { text: ` `, fontSize: 4 },
    value(" ", 266, "left"),
    { text: ` `, fontSize: 5 },
    { columns: [
      {text: "ผู้รับงาน :", width: "auto"},
      value(`${data.user || " "}`, 225, "left")
    ]},
    { columns: [
      {text: "แผนก : ", width: "auto"},
      value(`${data.user_type === "technical" ? "ช่าง" : "-"}`, 234, "left")
    ]},
    { text: ` `, fontSize: 50 },
    {
      text: `                ` + data.cause,
      alignment: "left",
      fontSize: 16,
      absolutePosition: { x: 17, y: 293 },
      textWrap: true,
      preserveLeadingSpaces: true,
    }
  ]);
  var docDefinition = {
    pageSize: {
      width: 302,
      height: "auto",
    },

    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [15, 15, 15, 15],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบเสร็จรับเงิน/ใบกำกับภาษี
async function report_receipt_tax(uid, other) {
  let data = {};
  let result = await GET(
    other.type === "billing"
      ? "admin/billing-notes/list"
      : other.type === "invoice"
      ? "admin/invoices/list"
      : other.type === "repair"
      ? "admin/repairs/list"
      : other.type === "billing-notes"
      ? "admin/billing-notes/list"
      : "admin/sales/list",
    { uid }
  );
  if (result?.status) {
    const item = result.data;
    if (other.type === "billing") {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address:
          item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list: item.invoice || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat,
        vat: item.vat,
        ...other,
      };
    } else if (other.type === "invoice") {
      if (item.sale) {
        data = {
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name:
            item.sale?.customer_name || item.sale?.customer?.full_name || "-",
          customer_phone:
            item.sale?.customer_phone || item.sale?.customer?.phone || "-",
          customer_address:
            item.sale?.customer_address || item.sale?.customer?.address || "-",
          customer_tax: item.sale?.customer?.tax_number || "-",
          transaction_list: item.sale?.transaction_list || [],
          amount: item.sale?.amount,
          amount_deposit: item.sale?.amount_deposit,
          total_pay: item.sale?.total_pay,
          is_vat: item.sale?.is_vat,
          vat: item.vat,
          ...other,
        };
      } else if (item.repair) {
        data = {
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name:
            item.repair?.customer_name ||
            item.repair?.customer?.full_name ||
            "-",
          customer_phone:
            item.repair?.customer_phone || item.repair?.customer?.phone || "-",
          customer_address:
            item.repair?.customer_address ||
            item.repair?.customer?.address ||
            "-",
          customer_tax: item.repair?.customer?.tax_number || "-",
          ...repairReceiptFields(item.repair),
          ...other,
        };
      }
    } else if (other.type === "repair") {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address:
          item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        ...repairReceiptFields(item),
        ...other,
      };
    } else {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address:
          item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list: item.transaction_list || item.invoice || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat,
        vat: item.vat,
        ...other,
      };
    }
  }
  const isCompact = other.compact === true;
  const fsCompany = isCompact ? 24 : 28;
  const fsAddress = isCompact ? 16 : 18;
  const fsBody = isCompact ? 15 : 16;
  const fsTitle = isCompact ? 18 : 20;
  const fsDisclaimer = isCompact ? 14 : 16;
  const fsSpacer = isCompact ? 2 : 4;
  const valueWidthCash = isCompact ? 430 : 450;
  const valueWidthTransfer = isCompact ? 390 : 410;
  const valueWidthCheque = isCompact ? 427 : 447;
  const signatureStack = isCompact
    ? [
        {
          columns: [
            " ",
            { text: "ผู้รับเงิน", width: "auto", fontSize: fsBody },
            value(" ", 200),
            " ",
          ],
        },
        {
          text: "Bill Collector",
          fontSize: fsBody,
          alignment: "center",
        },
      ]
    : [
        { text: ` `, fontSize: 16 },
        {
          columns: [
            " ",
            { text: "ผู้รับเงิน", width: "auto" },
            value(" ", 200),
            " ",
          ],
        },
        { text: "Bill Collector", fontSize: 16, alignment: "center" },
      ];
  const taxDeposit = Number(data.amount_deposit || 0);
  const taxBilled = Number(data.amount || 0) + Number(data.vat || 0);
  const taxTotalPay = Number(data.total_pay || 0);
  const taxOutstanding = taxBilled - taxTotalPay;
  const taxItemRows = data.transaction_list.map((item, index) => [
    { text: `${index + 1}`, alignment: "center", border: [1, 0, 1, 0] },
    {
      text: formatReceiptTaxItemLine(item, other.type === "repair"),
      alignment: "left",
      border: [1, 0, 1, 0],
    },
    {
      text: `${format_date(item.created_at || item.sale?.created_at)}`,
      alignment: "right",
      border: [1, 0, 1, 0],
    },
    {
      text: `${toFixed(
        item.sale
          ? Number(item.sale.amount) - Number(item.sale?.discount)
          : Number(item.qty) * Number(item.unit_price) -
            Number(item.discount)
      )}`,
      alignment: "right",
      border: [1, 0, 1, 0],
    },
  ]);
  const taxSummaryRows = [
    [
      {
        text: `(${ThaiBahtText(taxBilled) || "ศูนย์บาทถ้วน"})`,
        alignment: "left",
        colSpan: 2,
      },
      "",
      { text: "รวมเป็นเงิน", alignment: "right" },
      {
        text: toFixed(Number(data.amount || 0)),
        alignment: "right",
      },
    ],
    [
      {
        text: " ",
        alignment: "left",
        colSpan: 2,
        border: [0, 0, 0, 0],
      },
      "",
      { text: "ภาษีมูลค่าเพิ่ม 7%", alignment: "right" },
      { text: toFixed(Number(data.vat || 0)), alignment: "right" },
    ],
  ];
  if (taxDeposit > 0) {
    taxSummaryRows.push([
      {
        text: " ",
        alignment: "left",
        colSpan: 2,
        border: [0, 0, 0, 0],
      },
      "",
      { text: "หักมัดจำ", alignment: "right" },
      { text: `-${toFixed(taxDeposit)}`, alignment: "right" },
    ]);
  }
  taxSummaryRows.push(
    [
      {
        text: " ",
        alignment: "left",
        colSpan: 2,
        border: [0, 0, 0, 0],
      },
      "",
      { text: "ชำระแล้ว", alignment: "right" },
      { text: toFixed(taxTotalPay), alignment: "right" },
    ],
    [
      {
        text: " ",
        alignment: "left",
        colSpan: 2,
        border: [0, 0, 0, 0],
      },
      "",
      { text: "ยอดค้างชำระ", alignment: "right" },
      {
        text: toFixed(taxOutstanding),
        alignment: "right",
      },
    ]
  );
  const taxTableBody = [
    [
      {
        stack: [
          { text: "ลำดับ", alignment: "center" },
          { text: "No.", alignment: "center" },
        ],
      },
      {
        stack: [
          { text: "ใบส่งสินค้าเลขที่", alignment: "center" },
          { text: "Order No.", alignment: "center" },
        ],
      },
      {
        stack: [
          { text: "วันที่ใบส่งของ", alignment: "center" },
          { text: "Delivery Date", alignment: "center" },
        ],
      },
      {
        stack: [
          { text: "จำนวน", alignment: "center" },
          { text: "Amount", alignment: "center" },
        ],
      },
    ],
    ...taxItemRows,
    ...taxSummaryRows,
  ];
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: fsCompany,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: fsAddress,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: fsBody,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบเสร็จรับเงิน/ใบกำกับภาษี`,
      fontSize: fsTitle,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: fsSpacer },
    {
      columns: [
        {
          text: `เลขที่ : ${data.document_no}`,
          fontSize: fsBody,
          bold: true,
        },
        {
          text: `วันที่ : ${format_date(
            data.created_at,
            "dd mmmm yyyy",
            "th"
          )}`,
          fontSize: fsBody,
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ลูกค้า : ${data.customer_name}`,
          fontSize: fsBody,
          bold: true,
        },
        {
          text: `เบอร์โทรศัพท์ : ${data.customer_phone}`,
          fontSize: fsBody,
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ที่อยู่ : ${data.customer_address}`,
          fontSize: fsBody,
          bold: true,
        },
        {
          text: `เลขประจำตัวผู้เสียภาษี : ${data.customer_tax}`,
          fontSize: fsBody,
          bold: true,
        },
      ],
    },
    {
      table: {
        headerRows: 1,
        widths: [40, "*", 80, 80],
        body: taxTableBody,
      },
    },
    { text: ` `, fontSize: fsSpacer },
    {
      table: {
        headerRows: 1,
        widths: ["*"],
        body: [
          [{ text: "ได้รับ/Received", alignment: "center" }],
          [
            {
              stack: [
                {
                  columns: [
                    { text: "เงินสด/Cash", width: "auto" },
                    value(
                      data.cash_amount
                        ? toFixed(Number(data.cash_amount))
                        : " ",
                      valueWidthCash,
                      "left"
                    ),
                  ],
                },
                {
                  columns: [
                    { text: "โอนเข้าบัญชี/Transfer", width: "auto" },
                    value(
                      (Number(data.transfer_amount) > 0
                        ? toFixed(Number(data.transfer_amount)) + " บาท"
                        : "") +
                        " " +
                        (data.transfer_bank_account
                          ? "บัญชี: " + data.transfer_bank_account
                          : "") +
                        " " +
                        (data.transfer_date
                          ? "วันที่โอน: " + format_date(data.transfer_date)
                          : "") +
                        " " +
                        (data.transfer_time ? " " + data.transfer_time : ""),
                      valueWidthTransfer,
                      "left"
                    ),
                  ],
                },
                {
                  columns: [
                    { text: "เช็ค/Cheque", width: "auto" },
                    value(
                      (Number(data.credit_amount) > 0
                        ? toFixed(Number(data.credit_amount)) + " บาท"
                        : "") +
                        " " +
                        (data.credit_bank_account
                          ? "บัญชี: " + data.credit_bank_account
                          : "") +
                        " " +
                        (data.credit_date
                          ? "วันที่เช็ค: " + format_date(data.credit_date)
                          : "") +
                        " " +
                        (data.check_number ? " " + data.check_number : ""),
                      valueWidthCheque,
                      "left"
                    ),
                  ],
                },
              ],
            },
          ],
          [
            {
              stack: signatureStack,
            },
          ],
        ],
      },
    },
    ...(isCompact
      ? [
          {
            stack: [
              {
                text: "หากเป็นการชำระด้วยเช็ค ใบเสร็จรับเงินนี้จะสมบูรณ์ เมื่อห้างฯ ขึ้นเงินตามเช็คจากธนาคารได้แล้ว",
                fontSize: fsDisclaimer,
                alignment: "center",
              },
              {
                text: "If paid by cheque this cash bill is vlid cheque is cleared.",
                fontSize: fsDisclaimer,
                alignment: "center",
              },
            ],
          },
        ]
      : [
          { text: ` `, fontSize: 4 },
          {
            text: "หากเป็นการชำระด้วยเช็ค ใบเสร็จรับเงินนี้จะสมบูรณ์ เมื่อห้างฯ ขึ้นเงินตามเช็คจากธนาคารได้แล้ว",
            fontSize: fsDisclaimer,
            alignment: "center",
          },
          {
            text: "If paid by cheque this cash bill is vlid cheque is cleared.",
            fontSize: fsDisclaimer,
            alignment: "center",
          },
        ]),
  ]);
  const copyLabel = {
    fontSize: fsBody,
    alignment: "right",
    bold: true,
    ...(isCompact ? { margin: [0, 0, 0, 2] } : {}),
  };
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, ...copyLabel },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, ...copyLabel },
      ...JSON.parse(body),
    ],
    defaultStyle: {
      font: "THSarabunNew",
      fontSize: fsBody,
      lineHeight: isCompact ? 0.95 : 1,
    },
    pageMargins: isCompact ? [25, 25, 25, 25] : [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบเสร็จรับเงิน
async function report_receipt(uid, other) {
  let data = {};
  let result = await GET(
    other.type === "billing"
      ? "admin/billing-notes/list"
      : other.type === "invoice"
      ? "admin/invoices/list"
      : other.type === "repair"
      ? "admin/repairs/list"
      : other.type === "billing-notes"
      ? "admin/billing-notes/list"
      : "admin/sales/list",
    { uid }
  );
  if (result?.status) {
    const item = result.data;
    if (other.type === "billing") {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address:
          item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list: item.invoice || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat,
        vat: item.vat,
        ...other,
      };
    } else if (other.type === "invoice") {
      if (item.sale) {
        data = {
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name:
            item.sale?.customer_name || item.sale?.customer?.full_name || "-",
          customer_phone:
            item.sale?.customer_phone || item.sale?.customer?.phone || "-",
          customer_address:
            item.sale?.customer_address || item.sale?.customer?.address || "-",
          customer_tax: item.sale?.customer?.tax_number || "-",
          transaction_list: item.sale?.transaction_list || [],
          amount: item.sale?.amount,
          amount_deposit: item.sale?.amount_deposit,
          total_pay: item.sale?.total_pay,
          is_vat: item.sale?.is_vat,
          vat: item.vat,
          ...other,
        };
      } else if (item.repair) {
        data = {
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name:
            item.repair?.customer_name ||
            item.repair?.customer?.full_name ||
            "-",
          customer_phone:
            item.repair?.customer_phone || item.repair?.customer?.phone || "-",
          customer_address:
            item.repair?.customer_address ||
            item.repair?.customer?.address ||
            "-",
          customer_tax: item.repair?.customer?.tax_number || "-",
          transaction_list:
            [
              ...item.repair?.stock_activity_list
                .map((e) => e.transaction_list)
                .flat(),
              ...item.repair?.transaction_list,
            ] || [],
          amount: item.repair?.amount,
          amount_deposit: item.repair?.amount_deposit,
          total_pay: item.repair?.total_pay,
          is_vat: item.repair?.is_vat,
          vat: item.vat,
          ...other,
        };
      }
    } else if (other.type === "repair") {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address:
          item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list:
          [
            ...item.stock_activity_list.map((e) => e.transaction_list).flat(),
            ...item.transaction_list,
          ] || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat,
        vat: item.vat,
        ...other,
      };
    } else {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name: item.customer_name || item.customer?.full_name || "-",
        customer_phone: item.customer_phone || item.customer?.phone || "-",
        customer_address:
          item.customer_address || item.customer?.address || "-",
        customer_tax: item.customer?.tax_number || "-",
        transaction_list: item.transaction_list || item.invoice || [],
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        is_vat: item.is_vat,
        vat: item.vat,
        ...other,
      };
    }
  }
  let _total = 0;
  for (let item of data.transaction_list) {
    _total += item.sale
      ? Number(item.sale.amount) + Number(data.vat)
      : Number(item.qty) * Number(item.unit_price) + Number(data.vat);
    if (item?.credit_note) {
      for (let credit of item?.credit_note) {
        _total -= Number(credit.amount) + Number(data.vat);
      }
    }
  }
  const receiptDeposit = Number(data.amount_deposit || 0);
  const receiptTotalPay = Number(data.total_pay || 0);
  const receiptDataRows = data.transaction_list
    .map((item, index) => {
      let rows = [
        [
          { text: index + 1, alignment: "center" },
          {
            text: `${item.product_code || ""} ${
              item.product_name || ""
            } ${item.remark || ""} ${item.document_no || ""}`,
          },
          {
            text: format_date(item.created_at || item.sale?.created_at),
            alignment: "center",
          },
          {
            text: toFixed(
              item.sale
                ? Number(item.sale.amount)
                : Number(item.qty) * Number(item.unit_price)
            ),
            alignment: "right",
          },
          {
            text: toFixed(item.total_pay || item.sale?.total_pay || 0),
            alignment: "right",
          },
        ],
      ];

      let creditIndex = 1;
      for (let credit of item.credit_note || []) {
        rows.push([
          { text: `${index + 1}.${creditIndex}`, alignment: "center" },
          { text: credit.document_no || "" },
          {
            text: format_date(credit.created_at),
            alignment: "center",
          },
          {
            text: `-${toFixed(
              Number(credit.amount) + Number(credit.vat)
            )}`,
            alignment: "right",
          },
          { text: "", alignment: "right" },
        ]);
        creditIndex++;
      }

      return rows;
    })
    .flat();
  const receiptSummaryRows = [
    [
      { text: `ภาษีมูลค่าเพิ่ม 7%`, alignment: "right", colSpan: 3 },
      "",
      "",
      {
        text: toFixed(Number(data.vat)),
        alignment: "right",
      },
      {
        text: "0.00",
        alignment: "right",
      },
    ],
  ];
  if (receiptDeposit > 0) {
    receiptSummaryRows.push([
      { text: `หักมัดจำ`, alignment: "right", colSpan: 3 },
      "",
      "",
      {
        text: `-${toFixed(receiptDeposit)}`,
        alignment: "right",
      },
      {
        text: "",
        alignment: "right",
      },
    ]);
  }
  receiptSummaryRows.push([
    {
      text: `รวมเป็นเงิน (${ThaiBahtText(receiptTotalPay) || "ศูนย์บาทถ้วน"})`,
      alignment: "right",
      colSpan: 3,
    },
    "",
    "",
    {
      text: toFixed(_total),
      alignment: "right",
    },
    {
      text: toFixed(receiptTotalPay),
      alignment: "right",
    },
  ]);
  const receiptTableBody = [
    [
      {
        stack: [
          { text: "ลำดับ", alignment: "center" },
          { text: "No.", alignment: "center" },
        ],
        alignment: "center",
      },
      {
        stack: [
          { text: "ใบส่งสินค้าเลขที่", alignment: "center" },
          { text: "Order No.", alignment: "center" },
        ],
      },
      {
        stack: [
          { text: "วันที่ใบส่งของ", alignment: "center" },
          { text: "Delivery Date", alignment: "center" },
        ],
      },
      {
        stack: [
          { text: "จำนวนเงิน", alignment: "center" },
          { text: "Amount", alignment: "center" },
        ],
      },
      {
        stack: [
          { text: "ยอดชำระ", alignment: "center" },
          { text: "Total Pay", alignment: "center" },
        ],
      },
    ],
    ...receiptDataRows,
    ...receiptSummaryRows,
  ];
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบเสร็จรับเงิน`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        { text: `เลขที่ : ${data.document_no}`, fontSize: 16, bold: true },
        {
          text: `วันที่ : ${format_date(
            data.created_at,
            "dd mmmm yyyy",
            "th"
          )}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    {
      columns: [
        { text: `ลูกค้า : ${data.customer_name}`, fontSize: 16, bold: true },
        {
          text: `เบอร์โทรศัพท์ : ${data.customer_phone}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ที่อยู่ : ${data.customer_address}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `เลขประจำตัวผู้เสียภาษี : ${data.customer_tax}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    {
      table: {
        headerRows: 1,
        widths: [40, "*", 80, 60, 60],
        body: receiptTableBody,
      },
    },
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: ["*"],
        body: [
          [{ text: "ได้รับ/Received", alignment: "center" }],
          [
            {
              stack: [
                {
                  columns: [
                    { text: "เงินสด/Cash", width: "auto" },
                    value(
                      Number(data.cash_amount)
                        ? toFixed(Number(data.cash_amount))
                        : " ",
                      450,
                      "left"
                    ),
                  ],
                },
                {
                  columns: [
                    { text: "โอนเข้าบัญชี/Transfer", width: "auto" },
                    value(
                      (Number(data.transfer_amount) > 0
                        ? toFixed(Number(data.transfer_amount)) + " บาท"
                        : "") +
                        " " +
                        (data.transfer_bank_account
                          ? "บัญชี: " + data.transfer_bank_account
                          : "") +
                        " " +
                        (data.transfer_date
                          ? "วันที่โอน: " + format_date(data.transfer_date)
                          : "") +
                        " " +
                        (data.transfer_time ? " " + data.transfer_time : ""),
                      410,
                      "left"
                    ),
                  ],
                },
                {
                  columns: [
                    { text: "เช็ค/Cheque", width: "auto" },
                    value(
                      (Number(data.credit_amount) > 0
                        ? toFixed(Number(data.credit_amount)) + " บาท"
                        : "") +
                        " " +
                        (data.credit_bank_account
                          ? "บัญชี: " + data.credit_bank_account
                          : "") +
                        " " +
                        (data.credit_date
                          ? "วันที่เช็ค: " + format_date(data.credit_date)
                          : "") +
                        " " +
                        (data.check_number ? " " + data.check_number : ""),
                      447,
                      "left"
                    ),
                  ],
                },
              ],
            },
          ],
          [
            {
              stack: [
                { text: ` `, fontSize: 16 },
                {
                  columns: [
                    " ",
                    { text: "ผู้รับเงิน", width: "auto" },
                    value(" ", 200),
                    " ",
                  ],
                },
                { text: "Bill Collector", fontSize: 16, alignment: "center" },
              ],
            },
          ],
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    {
      text: "หากเป็นการชำระด้วยเช็ค ใบเสร็จรับเงินนี้จะสมบูรณ์ เมื่อห้างฯ ขึ้นเงินตามเช็คจากธนาคารได้แล้ว",
      fontSize: 16,
      alignment: "center",
    },
    {
      text: "If paid by cheque this cash bill is vlid cheque is cleared.",
      fontSize: 16,
      alignment: "center",
    },
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบสัญญายืมหรือซื้อสินค้าชั่วคราว
async function report_contract(uid, other) {
  let data = {};
  let result = await GET("admin/sales/list", { uid });
  if (result?.status) {
    const item = result.data;
    let transaction_list = item.transaction_list || item.invoice || [];
    data = {
      document_no: item.document_no,
      created_at: item.created_at,

      customer_name: item.customer_name || item.customer?.full_name || "-",
      warehouse_name: item.warehouse?.name || "-",

      transaction_list,
      amount: item.amount,
      amount_deposit: item.amount_deposit,
      total_pay: item.total_pay,
      is_vat: item.is_vat,
      vat: item.vat,
      remark: item.remark || null,
      ...other,
    };
    setTimeout(() => {
      window.close();
    }, 200);
  }
  const body = JSON.stringify([
    {
      image: 'data:image/png;base64,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',
      fit: [90, 60],
      absolutePosition: { x: 70, y: 30 }
    },
    {
      text: `ใบสัญญายืมหรือซื้อสินค้าชั่วคราว`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      text: `เลขที่เอกสาร : ${data.document_no}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    {
      text: `วันที่ : ${format_date(data.created_at, "dd mmmm yyyy")}`,
      alignment: "left",
      fontSize: 16,
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        {text: `ข้าพเจ้า (ห้างร้าน,ตัวแทน)`, width: "auto"},
        value(data.customer_name , 135),
        {text: `ได้ยืมสินค้าจาก`, width: "auto"},
        value("ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000)" , 205),
         ],
    },
    {text: `ไปในสภาพเรียบร้อย และไม่มีสิ่งใดชำรุดบกพร่องแต่ประการใด ภายใน 5 วัน หากไม่ได้นำสินค้ามาคืนตามสภาพเดิม ถือว่าได้ซื้อสินค้านั้นไป จะต้องชำระเงินตามรายการข้างล่างดังกล่าวนี้ ไม่ว่ากรณีใด ๆ`},
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: [40, "*", 80, 80],
        body: [
          [
            { text: "จำนวน", alignment: "center" },
            { text: "รายการ", alignment: "left" },
            { text: "ราคาต่อหน่วย", alignment: "right" },
            { text: "จำนวนเงิน", alignment: "right" },
          ],
          ...data.transaction_list.map((item, index) => [
            { text: `${item.qty}`, alignment: "center", border: [1, 0, 1, 0] },
            {
              text: `${item.product_code || " "} ${item.product_name || " "} ${
                item.remark || " "
              }`,
              alignment: "left",
              border: [1, 0, 1, 0],
            },
            {
              text: `${
                item.unit_price
                  ? toFixed(
                      (item.unit_price - item.discount)
                    )
                  : " "
              }`,
              alignment: "right",
              border: [1, 0, 1, 0],
            },
            {
              text: `${
                item.unit_price
                  ? toFixed(
                      Number(item.qty) *
                        Number(item.unit_price)
                    )
                  : " "
              }`,
              alignment: "right",
              border: [1, 0, 1, 0],
            },
          ]),
          [
            {
              text: `ภาษีมูลค่าเพิ่ม 7%`,
              alignment: "left",
              colSpan: 3,
            },
            "",
            "",
            {
              text: toFixed(Number(data.vat)),
              alignment: "right",
            },
          ],
          [
            {
              text: `รวมยอด (${
                ThaiBahtText(Number(data.amount) + Number(data.vat || 0)) ||
                "ศูนย์บาทถ้วน"
              })`,
              alignment: "left",
              colSpan: 3,
            },
            "",
            "",
            {
              text: toFixed(Number(data.amount) + Number(data.vat || 0)),
              alignment: "right",
            },
          ],
          [
            {
              text: `หมายเหตุ : ${data.remark || "-"}`,
              alignment: "left",
              colSpan: 4,
            },
            "",
            "",
            "",
          ],
          [
            {
              text: "กรุณาตรวจดูสินค้าให้เรียบร้อยก่อน ถ้าพ้นกําหนด 5 วัน ทางร้านจะไม่รับผิดชอบ ไม่ว่ากรณีใดๆ ทั้งสิ้น และท่านจะต้องชําระค่าสินค้าตามสัญญาฯ นี้ทุกประการ",
              alignment: "left",
              colSpan: 4,
            },
            "",
            "",
            "",
          ],
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    {
          text: "                ข้าพเจ้าได้อ่านสัญญายืมสินค้าและซื้อสินค้าชั่วคราวนี้ดีแล้ว และยินดีชำระเงินตามรายการสินค้า ตามรายการข้างต้นนี้ จึงลงลายมือชื่อนี้เป็นสำคัญต่อหน้าพยาน",
          alignment: "left",
          fontSize: 16,
          bold: true,
          preserveLeadingSpaces: true,
        },
        { text: ` `, fontSize: 4 },
        {
          columns: [
            {
              stack: [
                {
                  columns: [
                    { text: "วันที่", width: "auto" },
                    value(
                      data.credit_date ? format_date(data.credit_date) : "",
                      100
                    ),
                    { text: "เลขที่เช็ค", width: "auto" },
                    value(data.check_number, 100),
                  ],
                },
                {
                  columns: [
                    { text: "ธนาคาร", width: "auto" },
                    value(data.credit_bank_account, 100),
                    { text: "สาขา", width: "auto" },
                    value("-", 100),
                  ],
                },
                {
                  columns: [
                    { text: "จำนวนเงิน", width: "auto" },
                    value(
                      data.credit_amount ? toFixed(data.credit_amount) : "",
                      210
                    ),
                  ],
                },
                {
                  columns: [
                    { text: "ลงชื่อผู้จ่ายเช็ค", width: "auto" },
                    value("", 195),
                  ],
                },
              ],
            },
            {
              stack: [
                {
                  columns: [
                    { text: "ลงชื่อ", width: "auto" },
                    value("", 150),
                    { text: "ผู้ยืมสินค้าหรือรับสินค้า", width: "auto" },
                  ],
                },
                {
                  columns: [
                    { text: "", width: 20 },
                    { text: "(", width: "auto" },
                    value("", 150),
                    { text: ")", width: "auto" },
                  ],
                },
                {
                  columns: [
                    { text: "ลงชื่อ", width: "auto" },
                    value("", 150),
                    { text: "ผู้ให้ยืมสินค้า", width: "auto" },
                  ],
                },
                {
                  columns: [
                    { text: "", width: 20 },
                    { text: "(", width: "auto" },
                    value("", 150),
                    { text: ")", width: "auto" },
                  ],
                },
                {
                  columns: [
                    { text: "ลงชื่อ", width: "auto" },
                    value("", 150),
                    { text: "พยาน", width: "auto" },
                  ],
                },
                {
                  columns: [
                    { text: "ลงชื่อ", width: "auto" },
                    value("", 150),
                    { text: "พยาน", width: "auto" },
                  ],
                },
              ],
            },
          ],
        },
        {
          text: "หมายเหตุ หากเป็นกรณีชำระด้วยเช็ค หากไม่สามารถเรียกเก็บเงินตามเช็คได้ ไม่ว่ากรณีได ๆ ข้าพเจ้ายอมรับผิด ตามพระราช บัญญัติว่าด้วยความผิดอันเกิดจากการใช้เช็ค และยินยอมเสียดอกเบี้ย ในอัตราร้อยละ 15 ต่อปี ไปจนกว่าจะชำระแล้วเสร็จตาม สัญญา",
          alignment: "left",
          fontSize: 16,
          bold: true,
          preserveLeadingSpaces: true,
        },
  ]);
  var docDefinition = {
    pageSize: {
      width: 595.28,   // ความกว้าง A4
      height: 'auto'   // ความสูงยาวตาม content
    },
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบเสร็จรับเงิน
async function report_delivery_tax_invoice(uid, other) {
  let data = {};
  let result = await GET("admin/invoices/list", { uid });
  if (result?.status) {
    const item = result.data;
    if (item.sale) {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name:
          item.sale?.customer_name || item.sale?.customer?.full_name || "-",
        customer_phone:
          item.sale?.customer_phone || item.sale?.customer?.phone || "-",
        customer_address:
          item.sale?.customer_address || item.sale?.customer?.address || "-",
        customer_tax: item.sale?.customer?.tax_number || "-",
        transaction_list: item.sale?.transaction_list || [],
        amount: item.sale?.amount,
        amount_deposit: item.sale?.amount_deposit,
        total_pay: item.sale?.total_pay,
        ...other,
      };
    } else if (item.repair) {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name:
          item.repair?.customer_name || item.repair?.customer?.full_name || "-",
        customer_phone:
          item.repair?.customer_phone || item.repair?.customer?.phone || "-",
        customer_address:
          item.repair?.customer_address ||
          item.repair?.customer?.address ||
          "-",
        customer_tax: item.repair?.customer?.tax_number || "-",
        transaction_list:
          item.repair?.stock_activity_list
            .map((e) => e.transaction_list)
            .flat() || [],
        amount: item.repair?.amount,
        amount_deposit: item.repair?.amount_deposit,
        total_pay: item.repair?.total_pay,
        ...other,
      };
    }
  }
  let _total = 0;
  let _vat = 0;
  let _amount = 0;
  for (let item of data?.transaction_list) {
    _total += Number(item.unit_price) * Number(item.qty);
    _vat += Number(item.unit_price) * Number(item.qty);
    _amount += Number(item.unit_price) * Number(item.qty);
  }
  _vat = _vat * 0.07;
  _amount = _amount + Number(data.amount) * 0.07;
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบส่งของ/ใบกำกับภาษี`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
   {
  columns: [
    // ===== LEFT =====
    {
      width: "*",
      stack: [
        { text: `เลขที่ : ${data.document_no}`, fontSize: 16, bold: true },
        {
          text: `วันที่ : ${format_date(
            data.created_at,
            "dd mmmm yyyy",
            "th"
          )}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `ชื่อผู้ซื้อ : ${data.customer_name}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `เลขประจำตัวผู้เสียภาษี : ${data.customer_tax}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `ที่อยู่ : ${data.customer_address}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },

    // ===== RIGHT =====
    {
      width: "auto",
      stack: [
        {
          table: {
            widths: [110],
            body: [[{ text: "อัตราภาษีมูลค่าเพิ่ม 7%", alignment: "center" }]],
          },
          margin: [150, 0, 0, 6],
        },
        {
          columns: [
            checkbox(false),
            { text: "สำนักงานใหญ่", margin: [0, 0, 4, 0], width:"auto" },
            checkbox(false),
            { text: "สาขา", margin: [0, 0, 0, 0], width:"auto" },
            { ...value(" ", 130), width: "auto" },
          ],
          alignment: "right",
        },
      ],
      alignment: "right",
    },
  ],
},
 { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 2,
        widths: [40, "*", 60, 60, 30, 60, 30],
        body: [
          // ===== HEADER =====
          [
            { text: "ลำดับ", alignment: "center", rowSpan: 2 },
            { text: "รายการสินค้าหรือบริการ", alignment: "center", rowSpan: 2 },
            { text: "จำนวนหน่วย", alignment: "center", rowSpan: 2 },
            { text: "ราคาต่อหน่วย", alignment: "center", colSpan: 2 },
            "",
            { text: "มูลค่าสินค้าหรือบริการ", alignment: "center", colSpan: 2 },
            "",
          ],
          [
            "",
            "",
            "",
            { text: "บาท", alignment: "center" },
            { text: "สต.", alignment: "center" },
            { text: "บาท", alignment: "center" },
            { text: "สต.", alignment: "center" },
          ],
          // ===== DATA =====
          ...data.transaction_list.map((item, index) => [
            { text: index + 1, alignment: "center" },
            {
              text: `${item.product_code || ""} ${item.product_name || ""} ${
                item.remark || ""
              }`,
            },
            {
              text: `${item.qty || ""} ${item.unit_name || ""}`,
            },
            {
              text: toFixed(Number(item.unit_price)).split(".")[0],
              alignment: "right",
            },
            {
              text: toFixed(Number(item.unit_price)).split(".")[1],
              alignment: "right",
            },
            {
              text: toFixed(Number(item.unit_price) * Number(item.qty)).split(
                "."
              )[0],
              alignment: "right",
            },
            {
              text: toFixed(Number(item.unit_price) * Number(item.qty)).split(
                "."
              )[1],
              alignment: "right",
            },
          ]),

          // ===== SUMMARY =====
          [
            {
              text: "รวมมูลค่าสินค้าหรือบริการ",
              alignment: "right",
              colSpan: 5,
              border: [0, 0, 0, 0],
            },
            "",
            "",
            "",
            "",
            { text: toFixed(_total).split(".")[0], alignment: "right" },
            { text: toFixed(_total).split(".")[1], alignment: "right" },
          ],
          [
            {
              text: "จำนวนภาษีมูลค่าเพิ่ม",
              alignment: "right",
              colSpan: 5,
              border: [0, 0, 0, 0],
            },
            "",
            "",
            "",
            "",
            { text: toFixed(_vat).split(".")[0], alignment: "right" },
            { text: toFixed(_vat).split(".")[1], alignment: "right" },
          ],
          [
            {
              text: "จำนวนเงินรวมทั้งสิ้น	",
              alignment: "right",
              colSpan: 5,
              border: [0, 0, 0, 0],
            },
            "",
            "",
            "",
            "",
            { text: toFixed(_amount).split(".")[0], alignment: "right" },
            { text: toFixed(_amount).split(".")[1], alignment: "right" },
          ],
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    { text: "จำนวนเงินรวมทั้งสิ้น (ตัวอักษร)", fontSize: 16 },
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: ["*"],
        body: [
          [{ text: ThaiBahtText(Number(_amount)) || "ศูนย์บาทถ้วน", alignment: "left" }],
        ],
      },
    },
    { text: ` `, fontSize: 30 },
    {columns: [
      {stack: [
        {columns: [" ", {text: "ลงชื่อ",width:"auto"}, value(" ",150), {text: "ผู้รับสินค้า",width:"auto"}, " "]},
        {columns: [" ", {text: "(",width:"auto"}, value(" ",170), {text: ")",width:"auto"}, " "]},
        {columns: [" ", {text: "วันที่",width:"auto"}, value(" ",180), " "]},
      ]},
      {stack: [
        {columns: [" ", {text: "ลงชื่อ",width:"auto"}, value(" ",150), {text: "ผู้รับเงิน",width:"auto"}, " "]},
        {columns: [" ", {text: "(",width:"auto"}, value(" ",170), {text: ")",width:"auto"}, " "]},
        {columns: [" ", {text: "วันที่",width:"auto"}, value(" ",180), " "]},
      ]}
    ]}
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบส่งของ
async function report_delivery_note(uid, other) {
  let data = {};
  let result = await GET("admin/invoices/list", { uid });
  if (result?.status) {
    const item = result.data;
    if (item.sale) {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name:
          item.sale?.customer_name || item.sale?.customer?.full_name || "-",
        customer_phone:
          item.sale?.customer_phone || item.sale?.customer?.phone || "-",
        customer_address:
          item.sale?.customer_address || item.sale?.customer?.address || "-",
        customer_tax: item.sale?.customer?.tax_number || "-",
        transaction_list: item.sale?.transaction_list || [],
        amount: item.sale?.amount,
        amount_deposit: item.sale?.amount_deposit,
        total_pay: item.sale?.total_pay,
        ...other,
      };
    } else if (item.repair) {
      data = {
        document_no: item.document_no,
        created_at: item.created_at,
        customer_name:
          item.repair?.customer_name || item.repair?.customer?.full_name || "-",
        customer_phone:
          item.repair?.customer_phone || item.repair?.customer?.phone || "-",
        customer_address:
          item.repair?.customer_address ||
          item.repair?.customer?.address ||
          "-",
        customer_tax: item.repair?.customer?.tax_number || "-",
        transaction_list:
          item.repair?.stock_activity_list
            .map((e) => e.transaction_list)
            .flat() || [],
        amount: item.repair?.amount,
        amount_deposit: item.repair?.amount_deposit,
        total_pay: item.repair?.total_pay,
        ...other,
      };
    }
  }
  let _total = 0;
  for (let item of data?.transaction_list) {
    _total += Number(item.unit_price) * Number(item.qty);
  }
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบส่งของ`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
   {
  columns: [
    // ===== LEFT =====
    {
      width: "*",
      stack: [
        { text: `เลขที่ : ${data.document_no}`, fontSize: 16, bold: true },
        {
          text: `วันที่ : ${format_date(
            data.created_at,
            "dd mmmm yyyy",
            "th"
          )}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `ชื่อผู้ซื้อ : ${data.customer_name}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `เลขประจำตัวผู้เสียภาษี : ${data.customer_tax}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `ที่อยู่ : ${data.customer_address}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },

    // ===== RIGHT =====
    {
      width: "auto",
      stack: [
        {
          table: {
            widths: [110],
            body: [[{ text: "อัตราภาษีมูลค่าเพิ่ม 7%", alignment: "center" }]],
          },
          margin: [150, 0, 0, 6],
        },
        {
          columns: [
            checkbox(false),
            { text: "สำนักงานใหญ่", margin: [0, 0, 4, 0], width:"auto" },
            checkbox(false),
            { text: "สาขา", margin: [0, 0, 0, 0], width:"auto" },
            { ...value(" ", 130), width: "auto" },
          ],
          alignment: "right",
        },
      ],
      alignment: "right",
    },
  ],
},
 { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 2,
        widths: [40, "*", 60, 60, 30, 60, 30],
        body: [
          // ===== HEADER =====
          [
            { text: "ลำดับ", alignment: "center", rowSpan: 2 },
            { text: "รายการสินค้าหรือบริการ", alignment: "center", rowSpan: 2 },
            { text: "จำนวนหน่วย", alignment: "center", rowSpan: 2 },
            { text: "ราคาต่อหน่วย", alignment: "center", colSpan: 2 },
            "",
            { text: "มูลค่าสินค้าหรือบริการ", alignment: "center", colSpan: 2 },
            "",
          ],
          [
            "",
            "",
            "",
            { text: "บาท", alignment: "center" },
            { text: "สต.", alignment: "center" },
            { text: "บาท", alignment: "center" },
            { text: "สต.", alignment: "center" },
          ],
          // ===== DATA =====
          ...data.transaction_list.map((item, index) => [
            { text: index + 1, alignment: "center" },
            {
              text: `${item.product_code || ""} ${item.product_name || ""} ${
                item.remark || ""
              }`,
            },
            {
              text: `${item.qty || ""} ${item.unit_name || ""}`,
            },
            {
              text: toFixed(Number(item.unit_price)).split(".")[0],
              alignment: "right",
            },
            {
              text: toFixed(Number(item.unit_price)).split(".")[1],
              alignment: "right",
            },
            {
              text: toFixed(Number(item.unit_price) * Number(item.qty)).split(
                "."
              )[0],
              alignment: "right",
            },
            {
              text: toFixed(Number(item.unit_price) * Number(item.qty)).split(
                "."
              )[1],
              alignment: "right",
            },
          ]),

          // ===== SUMMARY =====
          [
            {
              text: "รวมมูลค่าสินค้าหรือบริการ",
              alignment: "right",
              colSpan: 5,
              border: [0, 0, 0, 0],
            },
            "",
            "",
            "",
            "",
            { text: toFixed(_total).split(".")[0], alignment: "right" },
            { text: toFixed(_total).split(".")[1], alignment: "right" },
          ],
          [
            {
              text: "จำนวนเงินรวมทั้งสิ้น	",
              alignment: "right",
              colSpan: 5,
              border: [0, 0, 0, 0],
            },
            "",
            "",
            "",
            "",
            { text: toFixed(_total).split(".")[0], alignment: "right" },
            { text: toFixed(_total).split(".")[1], alignment: "right" },
          ],
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    { text: "จำนวนเงินรวมทั้งสิ้น (ตัวอักษร)", fontSize: 16 },
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: ["*"],
        body: [
          [{ text: ThaiBahtText(Number(_total)) || "ศูนย์บาทถ้วน", alignment: "left" }],
        ],
      },
    },
    { text: ` `, fontSize: 30 },
    {columns: [
      {stack: [
        {columns: [" ", {text: "ลงชื่อ",width:"auto"}, value(" ",150), {text: "ผู้รับสินค้า",width:"auto"}, " "]},
        {columns: [" ", {text: "(",width:"auto"}, value(" ",170), {text: ")",width:"auto"}, " "]},
        {columns: [" ", {text: "วันที่",width:"auto"}, value(" ",180), " "]},
      ]},
      {stack: [
        {columns: [" ", {text: "ลงชื่อ",width:"auto"}, value(" ",150), {text: "ผู้รับเงิน",width:"auto"}, " "]},
        {columns: [" ", {text: "(",width:"auto"}, value(" ",170), {text: ")",width:"auto"}, " "]},
        {columns: [" ", {text: "วันที่",width:"auto"}, value(" ",180), " "]},
      ]}
    ]}
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบวางบิล
async function report_billing(uid, other) {
  let data = {};
  let result = await GET("admin/billing-notes/list", { uid });
  if (result?.status) {
    const item = result.data;
      data = {
      document_no: item.document_no,
      created_at: item.created_at,
      customer_name: item.customer?.full_name,
      customer_phone: item.customer?.phone,
      transaction_list: item.invoice || [],
      amount: item.amount,
      amount_deposit: item.amount_deposit,
      total_pay: item.total_pay,
        ...other,
      };
  }
  let _total = 0;
  let _amount = 0;
  for (let item of data.transaction_list) {
    _total += Number(item.sale?.total_pay || 0) ;
    
    let _total_cre = 0;
    for(let credit of item.credit_note){
      _total_cre +=  credit?.amount * (item.sale?.is_vat ? 1.07 : 1)
    }
    _amount +=( Number(item.sale?.amount || 0) * (item.sale?.is_vat ? 1.07 : 1))- _total_cre - Number(item.sale?.total_pay || 0) ;
  }
  if (_amount < 0) _amount = 0;
  let array = data.transaction_list.map((item, index) => {
      let arr = 
      [[
        { text: `${item.document_no || item.sale?.document_no || " "}`, alignment: "left", border:[1,0,1,0] },
        { text: `${item.sale?.created_at ? format_date(item.sale?.created_at, "dd/mm/yyyy", "th") : " "}`, alignment: "center", border:[1,0,1,0] },
        { text: `${item.sale?.payment_type || " "}`, alignment: "left", border:[1,0,1,0] },
        { text: `${item.sale?.due_date ? format_date(item.sale?.due_date, "dd/mm/yyyy", "th") : " "}`, alignment: "center", border:[1,0,1,0] },
        { text: `${item.sale?.amount ? toFixed(Number(item.sale?.amount) * (item.sale?.is_vat ? 1.07 : 1)) : " "}`, alignment: "right", border:[1,0,1,0] },
        { text: `${item.sale?.amount ? toFixed(Number(item.sale?.amount) * (item.sale?.is_vat ? 1.07 : 1)) : " "}`, alignment: "right", border:[1,0,1,0] },
      ]];
      if(item.credit_note){
      for(let credit of item.credit_note) {
        arr.push([
        { text: `${credit.document_no}`, alignment: "left", border:[1,0,1,0] },
        { text: `${format_date(credit.created_at, "dd/mm/yyyy", "th")}`, alignment: "center", border:[1,0,1,0] },
        { text: `ลดหนี้ (${item.sale?.document_no || item.document_no || " "})`, alignment: "left", border:[1,0,1,0] },
        { text: `${format_date(credit.due_date, "dd/mm/yyyy", "th")}`, alignment: "center", border:[1,0,1,0] },
        { text: `-${toFixed(credit?.amount * (item.sale?.is_vat ? 1.07 : 1))}`, alignment: "right", border:[1,0,1,0] },
        { text: `-${toFixed(credit?.amount * (item.sale?.is_vat ? 1.07 : 1))}`, alignment: "right", border:[1,0,1,0] },
      ])
      }
    }
    return arr;
  }).flat();
  let _null =  [ {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}]
  const max = [19, 40, 61].find(n => array.length <= n);
  if (max) { array = [ ...array, ...Array.from({ length: max - array.length }, () => _null) ] }; 
        
  const header = JSON.stringify([
    {stack: [
    {columns: [
      {stack:[
        {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "left",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "left",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "left",
      bold: true,
    },
      ],width:"*"},
      {
      table: {
        headerRows: 1,
        widths: [50],
        body: [
          // ===== HEADER =====
          [
            { text: "ใบวางบิล", alignment: "center" },
          ]
        ]
      },
      width:"auto"
    }
    ]},
    
    { text: ` `, fontSize: 4 },
    {
      columns: [
        { text: `เลขที่ : ${data.document_no}`, fontSize: 16, bold: true },
        {
          text: `วันที่ : ${format_date(
            data.created_at,
            "dd mmmm yyyy",
            "th"
          )}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    {
      columns: [
        { text: `ลูกค้า : ${data.customer_name}`, fontSize: 16, bold: true },
        {
          text: `เบอร์โทรศัพท์ : ${data.customer_phone}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    ],
    margin: [40, 0, 40, 0]}
  ]);
  const body = JSON.stringify([
    {
      table: {
        headerRows: 1,
        widths: [80,60,"*",60,60,75],
        body: [
          // ===== HEADER =====
          [
            { text: "เลขที่ใบส่งสินค้า", alignment: "center" },
            { text: "วันที่ใบส่งสินค้า", alignment: "center" },
            { text: "ประเภทเอกสาร", alignment: "center" },
            { text: "วันครบกำหนด", alignment: "center" },
            { text: "จำนวนเงิน", alignment: "center" },
            { text: "จำนวนเงินวางบิล", alignment: "center" },
          ],
          // ===== DATA =====
          ...array,

          // ===== SUMMARY =====
          [
            {
              text: "ยอดเงินที่ชำระแล้ว",
              colSpan: 5,
            },
            "",
            "",
            "",
            "",
            { text: toFixed(_total), alignment: "right" },
          ],
          [
            {
              text: `ยอดเงินค้างชำระ (${ThaiBahtText(Number(_amount || 0)) || "ศูนย์บาทถ้วน"})`,
              colSpan: 5,
            },
            "",
            "",
            "",
            "",
            { text: toFixed(_amount), alignment: "right" },
          ],
        ],
      },
    },
  ]);
  const footer = JSON.stringify([
    {columns: [
      {stack: [
        {columns: [" ", {text: "ผู้วางบิล",width:"auto"}, value(" ",160), " "]},
        {columns: [" ", {text: "ว/ด/ป",width:"auto"}, value(" ",170), " "]},
      ]},
      {stack: [
        {columns: [" ", {text: "ผู้รับวางบิล",width:"auto"}, value(" ",160), " "]},
        {columns: [" ", {text: "ว/ด/ป",width:"auto"}, value(" ",170), " "]},
      ]},
      
    ]}
  ]);
  var docDefinition = {
    pageSize: "A4",
    header: function (currentPage, pageCount) {
    const label = currentPage <= pageCount / 2 ? "ต้นฉบับ" : "สำเนา";

    return [
      {
        columns: [
          {
            text: label,
            fontSize: 16,
            bold: true,
            alignment: "right",
    margin: [40, 20, 40, 0]
          }
        ]
      },
      ...JSON.parse(header)
    ];
  },
    content: [
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      ...JSON.parse(body),
    ],
    footer: [
      ...JSON.parse(footer),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 14, lineHeight: 1 },
    pageMargins: [40, 170, 40, 80],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบลดหนี้
async function report_credit_note(uid, other) {
  let data = {};
  let [result,result_invoice] = await Promise.all([
      GET("admin/credit-notes/list", {uid}),
      GET("admin/invoices/list", {uid:other.ref_number}),
    ]);
    data = {...data,...other};
  if (result?.status) {
      const item = result.data;
      data = {
        ...data,
         document_no: item.document_no,
      created_at: item.created_at,
        transaction_list: item.transaction_credit_note || [],
        reason: item.reason || "",
        remark: item.remark || ""
      };
    }
    if (result_invoice?.status) {
      const item = result_invoice.data;
      data = {
        ...data,
      customer_name: item.sale?.customer?.full_name || "",
      customer_phone: item.sale?.customer?.phone || "",
      customer_address: item.sale?.customer?.address || "",
      ref_number: item.sale?.document_no || "",
      amount: item.sale?.amount,
      amount_deposit: item.sale?.amount_deposit,
      total_pay: item.sale?.total_pay,
      };
    }
    let array = data.transaction_list.map((item, index) => [
      { text: index + 1, alignment: "center", border:[1,0,1,0] },
      { text: `${item.product_name || ""} ${item.remark || ""}`, border:[1,0,1,0] },
      { text: `${item.qty || "0"} ${item.unit_name || ""}`, border:[1,0,1,0] },
      { text: toFixed(Number(item.unit_price)).split(".")[0], alignment: "right", border:[1,0,1,0] },
      { text: toFixed(Number(item.unit_price)).split(".")[1], alignment: "right", border:[1,0,1,0] },
      { text: toFixed(Number(item.unit_price) * Number(item.qty)).split(".")[0], alignment: "right", border:[1,0,1,0] },
      { text: toFixed(Number(item.unit_price) * Number(item.qty)).split(".")[1], alignment: "right", border:[1,0,1,0] },
    ]);
  let _null =  [ {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}, {text:" ",border:[1,0,1,0]}]
  const max = [10].find(n => array.length <= n);
  if (max) { array = [ ...array, ...Array.from({ length: max - array.length }, () => _null) ] }; 
      
   
  const header = JSON.stringify([
    {stack: [{
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบลดหนี้`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
   {
      columns: [
        { text: `เลขที่เอกสาร : ${data.document_no}`, fontSize: 16, bold: true },
        {
          text: `วันที่ : ${format_date(data.created_at,"dd mmmm yyyy","th")}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    {
      columns: [
        { text: `ชื่อผู้ซื้อ : ${data.customer_name}`, fontSize: 16, bold: true },
        {
          text: `เบอร์โทรศัพท์ : ${data.customer_phone}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    {
      columns: [
        {
          text: `ที่อยู่ : ${data.customer_address}`,
          fontSize: 16,
          bold: true,
        },
        {
          text: `เอกสารอ้างอิง : ${data.ref_number || ""}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },],
    margin: [40, 0, 40, 0]}
  ]);
  const body = JSON.stringify([
    {
      table: {
        headerRows: 2,
        widths: [25, "*", 30, 40, 17, 40, 17],
        body: [
          // ===== HEADER =====
          [
            { text: "ลำดับ", alignment: "center", rowSpan: 2 },
            { text: "รายการสินค้าหรือบริการ", alignment: "center", rowSpan: 2 },
            { text: "จำนวน", alignment: "center", rowSpan: 2 },
            { text: "ราคาต่อหน่วย", alignment: "center", colSpan: 2 },
            "",
            { text: "มูลค่าสินค้า", alignment: "center", colSpan: 2 },
            "",
          ],
          [
            "",
            "",
            "",
            { text: "บาท", alignment: "center" },
            { text: "สต.", alignment: "center" },
            { text: "บาท", alignment: "center" },
            { text: "สต.", alignment: "center" },
          ],
          // ===== DATA =====
          ...array,

          // ===== SUMMARY =====
          [
            { text: "มูลค่าสินค้าหรือบริการตามใบกำกับภาษีเดิม	", alignment: "right", colSpan: 5, border: [0, 1, 0, 0] }, "", "", "", "",
            { text: toFixed(data.amount).split(".")[0], alignment: "right" },
            { text: toFixed(data.amount).split(".")[1], alignment: "right" },
          ],
          [
            { text: "มูลค่าสินค้าหรือบริการที่ถูกต้อง", alignment: "right", colSpan: 5, border: [0, 0, 0, 0] }, "", "", "", "",
            { text: toFixed(Number(data.amount)-total(data.transaction_list,"unit_price")).split(".")[0], alignment: "right" },
            { text: toFixed(Number(data.amount)-total(data.transaction_list,"unit_price")).split(".")[1], alignment: "right" },
          ],
          [
            { text: "ผลต่าง", alignment: "right", colSpan: 5, border: [0, 0, 0, 0] }, "", "", "", "",
            { text: toFixed(total(data.transaction_list,"unit_price")).split(".")[0], alignment: "right" },
            { text: toFixed(total(data.transaction_list,"unit_price")).split(".")[1], alignment: "right" },
          ],
          [
            { text: "จำนวนเงินทั้งสิ้น", alignment: "right", colSpan: 5, border: [0, 0, 0, 0] }, "", "", "", "",
            { text: toFixed(Number(data.amount)-total(data.transaction_list,"unit_price")).split(".")[0], alignment: "right" },
            { text: toFixed(Number(data.amount)-total(data.transaction_list,"unit_price")).split(".")[1], alignment: "right" },
          ],
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    { text: `หมายเหตุในการลดหนี้ : ${data.reason || data.remark || "-"}`, fontSize: 16 },
    
  ]);
  const footer = JSON.stringify([
   {columns: [
      {stack: [
        {columns: [" ", {text: "ลงชื่อ",width:"auto"}, value(" ",150), {text: "ผู้ตรวจสอบ",width:"auto"}, " "]},
        {columns: [" ", {text: "(",width:"auto"}, value(" ",170), {text: ")",width:"auto"}, " "]},
        {columns: [" ", {text: "วันที่",width:"auto"}, value(" ",180), " "]},
      ]},
      {stack: [
        {columns: [" ", {text: "ลงชื่อ",width:"auto"}, value(" ",150), {text: "ผู้อนุมัติ",width:"auto"}, " "]},
        {columns: [" ", {text: "(",width:"auto"}, value(" ",170), {text: ")",width:"auto"}, " "]},
        {columns: [" ", {text: "วันที่",width:"auto"}, value(" ",180), " "]},
      ]}
    ]}
  ]);
  var docDefinition = {
    pageSize: "A4",
     header: function (currentPage, pageCount) {
    const label = currentPage <= pageCount / 2 ? "ต้นฉบับ" : "สำเนา";

    return [
      {
        columns: [
          {
            text: label,
            fontSize: 16,
            bold: true,
            alignment: "right",
    margin: [40, 20, 40, 0]
          }
        ]
      },
      ...JSON.parse(header)
    ];
  },
    content: [
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      ...JSON.parse(body),
    ],
     footer: [
      ...JSON.parse(footer),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 225, 40, 105],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// สรุปรายการติดตั้ง
async function report_installation_summary(uid, other) {
  let data = {};
  let [result, result_so] = await Promise.all([
        GET("admin/repairs/list", { uid }),
        GET("admin/sales/list", { page: 0, data_search: "", status_code: "เสร็จสิ้น" })
      ]);
  if (result?.status) {
      const item = result.data;
      data = {
          document_no: item.document_no,
          created_at: item.created_at,
          customer_name: item.customer?.full_name,
          customer_phone: item.customer?.phone,
          car_registration: item.car_registration,
          transaction_list: [...item.stock_activity_list.map(e=>e.transaction_list).flat(), ...item.transaction_list],
          amount: item.amount,
          amount_deposit: item.amount_deposit,
          total_pay: item.total_pay,
          discount: item.discount,
          is_vat: item.is_vat,
          transaction_so: [],
          cause: item.cause,
          ...other
        };
    }
    if(result.data?.ref_number){
      let result_sale = await GET("admin/sales/list", {uid: result_so.data.find(e=>e.document_no === result.data?.ref_number)?.uid});
        
          if (result_sale?.status) {
            const item = result_sale.data;
            data = {...data,transaction_so: item.transaction_list};
          }
    }
let _total = 0;
data.transaction_list.forEach((tx) => {
  _total += Number(tx.unit_price) * Number(tx.qty);
});
data.transaction_so?.forEach((tx) => {
  _total -= Number(tx.unit_price) * Number(tx.qty);
});
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `สรุปรายการติดตั้ง`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    { text: `เลขที่เอกสาร : ${data.document_no}`, fontSize: 16, bold: true },
   {
      columns: [
        {
          text: `วันที่ : ${format_date(data.created_at,"dd mmmm yyyy","th")}`,
          fontSize: 16,
          bold: true,
        },
        { text: `ทะเบียนรถ : ${data.car_registration}`, fontSize: 16, bold: true },
      ],
    },
    {
      columns: [
        { text: `ชื่อลูกค้า : ${data.customer_name}`, fontSize: 16, bold: true },
        {
          text: `เบอร์โทร : ${data.customer_phone}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
 { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: [40, "*", 60, 60, 60],
        body: [
          // ===== HEADER =====
          [
            { text: "ลำดับ", alignment: "center" },
            { text: "รายการ", alignment: "center" },
            { text: "จำนวน", alignment: "center" },
            { text: "ราคาต่อหน่วย", alignment: "center" },
            { text: "ราคารวม", alignment: "center" },
          ],
          // ===== DATA =====
          ...data.transaction_list.map((item, index) => [
            { text: `${index + 1}`, alignment: "center" },
            { text: `${item.product_code || ""} ${item.product_name || ""}`, alignment: "left" },
            { text: `${item.qty}`, alignment: "center" },
            { text: `${toFixed(item.unit_price * (data.is_vat ? 1.07 : 1))}`, alignment: "right" },
            { text: `${toFixed((Number(item.qty) * Number(item.unit_price)) * (data.is_vat ? 1.07 : 1))}`, alignment: "right" },
          ]),
          ...data.transaction_so.map((item, index) => [
            { text: `${data.transaction_list.length + index + 1}`, alignment: "center" },
            { text: `${item.product_code} ${item.product_name}`, alignment: "left" },
            { text: " ", alignment: "center" },
            { text: " ", alignment: "right" },
            { text: `-${toFixed((Number(item.qty) * Number(item.unit_price)))}`, alignment: "right" },
          ]),

          // ===== SUMMARY =====
          [
            { text: "ส่วนลด", alignment: "right", colSpan: 2 }, "", 
            { text: " ", alignment: "center" },
            { text: " ", alignment: "right" },
            { text: toFixed(data.discount), alignment: "right" },
          ],
          [
            { text: "ยอดรวมทั้งสิ้น", alignment: "right", colSpan: 2 }, "", 
            { text: total(data.transaction_list,"qty"), alignment: "center" },
            { text: " ", alignment: "right" },
            { text: toFixed((_total-data.discount) * (data.is_vat ? 1.07 : 1)), alignment: "right" },
          ],
        ],
      },
    },
    { text: ` `, fontSize: 12 },
    {
      stack: [
        {text: "หมายเหตุ",width:"auto"},
        value(data.remark || data.cause || "-",520,"left"),
        { text: ` `, fontSize: 8 },
        value(" ",520),
        { text: ` `, fontSize: 8 },
        value(" ",520),
        { text: ` `, fontSize: 8 },
        value(" ",520),
        { text: ` `, fontSize: 8 },
        value(" ",520),
        { text: ` `, fontSize: 8 },
        value(" ",520),
      ]
    }
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// รายการซ่อม
async function report_repair(uid, other) {
  let data = {};
   let [result, result_so] = await Promise.all([
        GET("admin/repairs/list", { uid }),
        GET("admin/sales/list", { page: 0, data_search: "", status_code: "เสร็จสิ้น" })
      ]);
  if (result?.status) {
    const item = result.data;
      data = {
        document_no: item.document_no,
          created_at: item.created_at,
          customer_name: item.customer?.full_name,
          customer_phone: item.customer?.phone,
          car_registration: item.car_registration,
          transaction_list: [...item.stock_activity_list.map(e=>e.transaction_list).flat(), ...item.transaction_list],
          amount: item.amount,
          amount_deposit: item.amount_deposit,
          total_pay: item.total_pay,
          is_vat: item.is_vat,
          discount: item.discount,
          transaction_so: [],
        ...other,
      }; 
  }if(result.data?.ref_number){
      let result_sale = await GET("admin/sales/list", {uid: result_so.data.find(e=>e.document_no === result.data?.ref_number)?.uid});
        
          if (result_sale?.status) {
            const item = result_sale.data;
            data = {...data,transaction_so: item.transaction_list};
          }
    }
   let _total = 0;
                  data.transaction_list.forEach((tx) => {
                    _total += Number(tx.unit_price) * Number(tx.qty);
                  });

data.transaction_so?.forEach((tx) => {
  _total -= Number(tx.unit_price) * Number(tx.qty);
});
  const body = JSON.stringify([
    {
      text: `รายการซ่อม`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
     { text: `เลขที่เอกสาร : ${data.document_no}`, fontSize: 16, bold: true },
    {
      columns: [
        {
          text: `วันที่ : ${format_date(
            data.created_at,
            "dd mmmm yyyy",
            "th"
          )}`,
          fontSize: 16,
          bold: true,
        },
        { text: `ทะเบียนรถ : ${data.car_registration || ""}`, fontSize: 16, bold: true },
      ],
    },
    {
      columns: [
        { text: `ลูกค้า : ${data.customer_name}`, fontSize: 16, bold: true },
        {
          text: `เบอร์โทรศัพท์ : ${data.customer_phone}`,
          fontSize: 16,
          bold: true,
        },
      ],
    },
    {
      table: {
        headerRows: 1,
        widths: [40, "*", 60, 60, 60],
        body: [
          [
            { text: "ลำดับที่", alignment: "center" },
            { text: "รายการ", alignment: "center" },
            { text: "จำนวน", alignment: "center" },
            { text: "ราคาต่อหน่วย", alignment: "center" },
            { text: "ราคารวม", alignment: "center" },
            
          ],
          ...data.transaction_list.map((item, index) => [
            { text: `${index + 1}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.product_code || ""} ${item.product_name || ""}`, alignment: "left", border: [1, 0, 1, 0] },
            { text: `${item.qty}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${toFixed(item.unit_price * (data.is_vat ? 1.07 : 1))}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed((Number(item.qty) * Number(item.unit_price)) * (data.is_vat ? 1.07 : 1))}`, alignment: "right", border: [1, 0, 1, 0] },
          ]),
          ...data.transaction_so.map((item, index) => [
            { text: `${data.transaction_list.length + index + 1}`, alignment: "center" },
            { text: `${item.product_code || ""} ${item.product_name || ""}`, alignment: "left" },
            { text: " ", alignment: "center" },
            { text: " ", alignment: "right" },
            { text: `-${toFixed((Number(item.qty) * Number(item.unit_price)) * (data.is_vat ? 1.07 : 1))}`, alignment: "right" },
          ]),

          // ===== SUMMARY =====
          [
            { text: "ส่วนลด", alignment: "right", colSpan: 2 }, "", 
            { text: " ", alignment: "center" },
            { text: " ", alignment: "right" },
            { text: toFixed(data.discount), alignment: "right" },
          ],
          [
            { text: "ยอดรวมทั้งสิ้น", alignment: "right", colSpan: 2 }, "", 
            { text: total(data.transaction_list,"qty"), alignment: "center" },
            { text: " ", alignment: "right" },
            { text: toFixed((_total-data.discount) * (data.is_vat ? 1.07 : 1)), alignment: "right" },
          ],
        ],
      },
    },
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบรับสินค้า
async function report_product_receipt(uid, other) {
  let data = {};
   let result = await GET("admin/stock-activities/list", { uid });
  if (result?.status) {
    const item = result.data;
      data = {
        document_no: item.document_no,
        company_name: item.supplier?.company_name || "",
        created_at: item.created_at,
        ref_number: item.ref_number || "",
        warehouse_name: item.warehouse?.name || "",
        customer_name: item.customer?.full_name,
        customer_phone: item.customer?.phone,
        transaction_list: item.transaction_list || [],
        is_vat: item.is_vat,
        amount: item.amount,
        amount_deposit: item.amount_deposit,
        total_pay: item.total_pay,
        discount: item.discount || 0,
        delivery_cost: item.delivery_cost || 0,
        remark: item.remark || "",
        ...other,
      };
  }
  let _total = 0;
  data.transaction_list.forEach((tx)=>{
    _total += (Number(tx.unit_price) * Number(tx.qty)) - Number(tx.discount);
  });
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบรับสินค้า`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        { text: `เลขที่เอกสาร : ${data.document_no}`, fontSize: 16, bold: true },
        { text: `ชื่อบริษัทจำหน่าย : ${data.company_name}`, fontSize: 16, bold: true },
      ],
    },
    {
      columns: [
        { text: `วันที่เอกสาร : ${format_date(data.created_at,"dd mmmm yyyy","th")}`, fontSize: 16, bold: true },
        { text: `เลขที่อ้างอิง PO : ${data.ref_number}`, fontSize: 16, bold: true },
      ],
    },
    { text: `คลังสินค้า : ${data.warehouse_name}`, fontSize: 16, bold: true },
    {
      table: {
        headerRows: 1,
        widths: [32, "*", 60, 30, 55, 35, 45, 45],
        body: [
          [
            { text: "ลำดับที่", alignment: "center" },
            { text: "รหัส/ชื่อสินค้า", alignment: "center" },
            { text: "Serial Number", alignment: "center" },
            { text: "จำนวน", alignment: "center" },
            { text: "ราคา/หน่วย", alignment: "center" },
            { text: "ส่วนลด", alignment: "center" },
            { text: "ราคาหลัง หักส่วนลด", alignment: "center" },
            { text: "มูลค่ารวม", alignment: "center" },
          ],
          ...data.transaction_list.map((item, index) => [
            { text: `${index + 1}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.product_code} ${item.product_name}`, alignment: "left", border: [1, 0, 1, 0] },
            { text: `${item.serial_number?.toString() || "-"}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.qty}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${toFixed(item.unit_price)}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed(item.discount)}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed((Number(item.unit_price) * Number(item.qty)) - Number(item.discount))}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed((Number(item.unit_price) * Number(item.qty)) - Number(item.discount))}`, alignment: "right", border: [1, 0, 1, 0] },
          ]),
          [
            { text: "รวมเป็นเงิน", alignment: "right", colSpan: 7, border: [0,1,0,0] }, "", "", "", "", "", "",
            { text: toFixed(_total), alignment: "right" },
          ],
          [
            { text: "ส่วนลด", alignment: "right", colSpan: 7, border: [0,0,0,0] }, "", "", "", "", "", "",
            { text: toFixed(data.discount), alignment: "right" },
          ],
          [
            { text: "ราคาหลังหักส่วนลด", alignment: "right", colSpan: 7, border: [0,0,0,0] }, "", "", "", "", "", "",
            { text: toFixed(_total-Number(data.discount)), alignment: "right" },
          ],
          [
            { text: "ภาษีมูลค่าเพิ่ม 7%", alignment: "right", colSpan: 7, border: [0,0,0,0] }, "", "", "", "", "", "",
            { text: toFixed(_total * 0.07), alignment: "right" },
          ],
          [
            { text: "ค่าส่ง", alignment: "right", colSpan: 7, border: [0,0,0,0] }, "", "", "", "", "", "",
            { text: toFixed(data.delivery_cost), alignment: "right" },
          ],
          [
            { text: "จำนวนเงินรวมทั้งหมด", alignment: "right", colSpan: 7, border: [0,0,0,0] }, "", "", "", "", "", "",
            { text: toFixed(data.amount), alignment: "right" },
          ],
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    {
      text: "หมายเหตุ : " + (data.remark || data.cause || "-"),
      fontSize: 16,
    },
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบเปลี่ยนสินค้า
async function report_change_product(uid, other) {
  let data = {};
  let result = await GET("admin/stock-activities/list", { uid });
  if (result?.status) {
    const item = result.data;
      data = {
        document_no: item.document_no,
        customer_name: item.customer?.full_name || "",
        customer_phone: item.customer?.phone || "",
        created_at: item.created_at,
        warehouse_name: item.warehouse?.name || "",
        user: item.user?.full_name || "",
        transaction_list: item.transaction_list || [],
        transaction_list_new: item.transaction_list_new || [],
        remark: item.remark || "",
        ...other,
      };
  }
  let _total = 0;
  data.transaction_list.forEach((tx)=>{
     _total += Number(tx.qty) * Number(tx.unit_price);
  });
  let _total_new = 0;
  data.transaction_list_new.forEach((tx)=>{
     _total_new += Number(tx.qty) * Number(tx.unit_price);
  });
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบเปลี่ยนสินค้า`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        { text: `เลขที่เอกสาร : ${data.document_no}`, fontSize: 16, bold: true },
        { text: `วันที่เอกสาร : ${format_date(data.created_at,"dd mmmm yyyy","th")}`, fontSize: 16, bold: true },
      ],
    },
    {
      columns: [
        { text: `ชื่อลูกค้า : ${data.customer_name}`, fontSize: 16, bold: true },
        { text: `เบอร์โทร : ${data.customer_phone}`, fontSize: 16, bold: true },
      ],
    },
    { text: `ที่อยู่ : -`, fontSize: 16, bold: true },
    {
      columns: [
        { text: `คลังสินค้า : ${data.warehouse_name}`, fontSize: 16, bold: true },
        { text: `ผู้ดำเนินการ : ${data.user}`, fontSize: 16, bold: true },
      ],
    },
    { text: ` `, fontSize: 4 },
    { text: `รายการคืน`, fontSize: 20, bold: true },
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: [32, "*", 70, 30, 55, 55],
        body: [
          [
            { text: "ลำดับที่", alignment: "center" },
            { text: "รหัส/ชื่อสินค้า", alignment: "center" },
            { text: "Serial Number", alignment: "center" },
            { text: "จำนวน", alignment: "center" },
            { text: "ราคา/หน่วย", alignment: "center" },
            { text: "มูลค่ารวม", alignment: "center" },
          ],
          ...data.transaction_list.map((item, index) => [
            { text: `${index + 1}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.product_code} ${item.product_name}`, alignment: "left", border: [1, 0, 1, 0] },
            { text: `${item.serial_number?.toString()}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.qty}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${toFixed(item.unit_price)}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed(Number(item.qty) * Number(item.unit_price))}`, alignment: "right", border: [1, 0, 1, 0] },
          ]),
          [
            { text: "รวมเป็นเงิน", alignment: "right", colSpan: 5, border: [0,1,0,0] }, "", "", "", "",
            { text: toFixed(_total), alignment: "right" },
          ]
        ],
      },
    },
     { text: ` `, fontSize: 4 },
    { text: `รายการใหม่`, fontSize: 20, bold: true },
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: [32, "*", 70, 30, 55, 55],
        body: [
          [
            { text: "ลำดับที่", alignment: "center" },
            { text: "รหัส/ชื่อสินค้า", alignment: "center" },
            { text: "Serial Number", alignment: "center" },
            { text: "จำนวน", alignment: "center" },
            { text: "ราคา/หน่วย", alignment: "center" },
            { text: "มูลค่ารวม", alignment: "center" },
          ],
          ...data.transaction_list_new.map((item, index) => [
            { text: `${index + 1}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.product_code} ${item.product_name}`, alignment: "left", border: [1, 0, 1, 0] },
            { text: `${item.serial_number?.toString()}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.qty}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${toFixed(item.unit_price)}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed(Number(item.qty) * Number(item.unit_price))}`, alignment: "right", border: [1, 0, 1, 0] },
          ]),
          [
            { text: "รวมเป็นเงิน", alignment: "right", colSpan: 5, border: [0,1,0,0] }, "", "", "", "",
            { text: toFixed(_total_new), alignment: "right" },
          ]
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    {
      text: "หมายเหตุ : " + (data.remark || data.cause || "-"),
      fontSize: 16,
    },
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบคืนสินค้า
async function report_return_product(uid, other) {
  let data = {};
  let result = await GET("admin/stock-activities/list", { uid });
  if (result?.status) {
    const item = result.data;
      data = {
        document_no: item.document_no,
        customer_name: item.customer?.full_name || "",
        customer_phone: item.customer?.phone || "",
        created_at: item.created_at,
        warehouse_name: item.warehouse?.name || "",
        user: item.user?.full_name || "",
        transaction_list: item.transaction_list || [],
        transaction_list_new: item.transaction_list_new || [],
        remark: item.remark || "",
        ...other,
      };
  }
  let _total = 0;
  data.transaction_list.forEach((tx)=>{
     _total += Number(tx.qty) * Number(tx.unit_price);
  });
  let _total_new = 0;
  data.transaction_list_new.forEach((tx)=>{
     _total_new += Number(tx.qty) * Number(tx.unit_price);
  });
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบคืนสินค้า`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        { text: `เลขที่เอกสาร : ${data.document_no}`, fontSize: 16, bold: true },
        { text: `วันที่เอกสาร : ${format_date(data.created_at,"dd mmmm yyyy","th")}`, fontSize: 16, bold: true },
      ],
    },
    {
      columns: [
        { text: `ชื่อลูกค้า : ${data.customer_name}`, fontSize: 16, bold: true },
        { text: `เบอร์โทร : ${data.customer_phone}`, fontSize: 16, bold: true },
      ],
    },
    { text: `ที่อยู่ : -`, fontSize: 16, bold: true },
    {
      columns: [
        { text: `คลังสินค้า : ${data.warehouse_name}`, fontSize: 16, bold: true },
        { text: `ผู้ดำเนินการ : ${data.user}`, fontSize: 16, bold: true },
      ],
    },
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: [32, "*", 70, 30, 55, 55],
        body: [
          [
            { text: "ลำดับที่", alignment: "center" },
            { text: "รหัส/ชื่อสินค้า", alignment: "center" },
            { text: "Serial Number", alignment: "center" },
            { text: "จำนวน", alignment: "center" },
            { text: "ราคา/หน่วย", alignment: "center" },
            { text: "มูลค่ารวม", alignment: "center" },
          ],
          ...data.transaction_list.map((item, index) => [
            { text: `${index + 1}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.product_code} ${item.product_name}`, alignment: "left", border: [1, 0, 1, 0] },
            { text: `${item.serial_number?.toString()}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.qty}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${toFixed(item.unit_price)}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed(Number(item.qty) * Number(item.unit_price))}`, alignment: "right", border: [1, 0, 1, 0] },
          ]),
          [
            { text: "รวมเป็นเงิน", alignment: "right", colSpan: 5, border: [0,1,0,0] }, "", "", "", "",
            { text: toFixed(_total), alignment: "right" },
          ]
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    {
      text: "หมายเหตุ : " + (data.remark || data.cause || "-"),
      fontSize: 16,
    },
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// ใบคืน/เคลมสินค้าผู้จำหน่าย
async function report_return_claim(uid, other) {
  let data = {};
  let result = await GET("admin/stock-activities/list", { uid });
  if (result?.status) {
    const item = result.data;
      data = {
         document_no: item.document_no,
          company_name: item.supplier?.company_name || "",
          created_at: item.created_at,
          activity_type: item.activity_type || "",
          warehouse_name: item.warehouse?.name || "",
          user: item.user?.full_name || "",
          transaction_list: item.transaction_list || [],
          remark: item.remark || "",
        ...other,
      };
  }
  let _total = 0;
  data.transaction_list.forEach((tx)=>{
     _total += Number(tx.qty) * Number(tx.unit_price);
  });
  const body = JSON.stringify([
    {
      text: `ห.จ.ก. เชียงใหม่เซียงกงอะไหล่ยนต์ (2000) สำนักงานใหญ่`,
      fontSize: 28,
      alignment: "center",
      bold: true,
    },
    {
      text: `61 ถ.ซุปเปอร์ไฮเวย์ เชียงใหม่ - ลำปาง ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่`,
      fontSize: 18,
      alignment: "center",
      bold: true,
    },
    {
      text: `โทร. (053) 211747, 213301, 215323 แฟกซ์ (053) 210060`,
      fontSize: 16,
      alignment: "center",
      bold: true,
    },
    {
      text: `ใบคืน/เคลมสินค้าผู้จำหน่าย`,
      fontSize: 20,
      alignment: "center",
      bold: true,
    },
    { text: ` `, fontSize: 4 },
    {
      columns: [
        { text: `เลขที่เอกสาร : ${data.document_no}`, fontSize: 16, bold: true },
        { text: `ชื่อบริษัทจำหน่าย : ${data.company_name}`, fontSize: 16, bold: true },
      ],
    },
    {
      columns: [
        { text: `วันที่เอกสาร : ${format_date(data.created_at,"dd mmmm yyyy","th")}`, fontSize: 16, bold: true },
        { text: `ประเภทการคืน : ${data.activity_type}`, fontSize: 16, bold: true },
      ],
    },
    {
      columns: [
        { text: `คลังสินค้า : ${data.warehouse_name}`, fontSize: 16, bold: true },
        { text: `ผู้ดำเนินการ : ${data.user}`, fontSize: 16, bold: true },
      ],
    },
    { text: ` `, fontSize: 4 },
    {
      table: {
        headerRows: 1,
        widths: [32, "*", 70, 45, 55, 55],
        body: [
          [
            { text: "ลำดับที่", alignment: "center" },
            { text: "รหัส/ชื่อสินค้า", alignment: "center" },
            { text: "Serial Number", alignment: "center" },
            { text: "จำนวน คืน/เคลม", alignment: "center" },
            { text: "ราคา/หน่วย", alignment: "center" },
            { text: "มูลค่ารวม", alignment: "center" },
          ],
          ...data.transaction_list.map((item, index) => [
            { text: `${index + 1}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.product_code} ${item.product_name}`, alignment: "left", border: [1, 0, 1, 0] },
            { text: `${item.serial_number?.toString()}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${item.qty}`, alignment: "center", border: [1, 0, 1, 0] },
            { text: `${toFixed(item.unit_price)}`, alignment: "right", border: [1, 0, 1, 0] },
            { text: `${toFixed(Number(item.qty) * Number(item.unit_price))}`, alignment: "right", border: [1, 0, 1, 0] },
          ]),
          [
            { text: "รวมเป็นเงิน", alignment: "right", colSpan: 5, border: [0,1,0,0] }, "", "", "", "",
            { text: toFixed(_total), alignment: "right" },
          ]
        ],
      },
    },
    { text: ` `, fontSize: 4 },
    {
      text: "หมายเหตุ : " + (data.remark || data.cause || "-"),
      fontSize: 16,
    },
  ]);
  var docDefinition = {
    pageSize: "A4",
    content: [
      { text: `ต้นฉบับ`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
      { text: "", pageBreak: "after" },
      { text: `สำเนา`, fontSize: 16, alignment: "right", bold: true },
      ...JSON.parse(body),
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

// รายการชำระเงิน
async function reports(title, data_list, font_size, pageOrientation = "landscape") {
  
  const body = JSON.stringify([
    { text: title, fontSize: 24, alignment: "left", bold: true },
    { text: ` `, fontSize: 4 },
    data_list,
    { text: ` `, fontSize: 4 },
  ]);
  var docDefinition = {
    pageSize: "A4",
    pageOrientation: pageOrientation,
    content: [
      ...JSON.parse(body)
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: font_size || 16, lineHeight: 1 },
    pageMargins: [40, 40, 40, 40],
  };

  print(docDefinition, "ใบเสนอราคา.pdf");
}

export {
  report_quotation,
  report_deposit,
  report_loan,
  report_get_spare_parts,
  report_car_receipt,
  report_receipt_tax,
  report_receipt,
  report_contract,
  report_delivery_tax_invoice,
  report_delivery_note,
  report_billing,
  report_credit_note,
  report_installation_summary,
  report_repair,
  report_product_receipt,
  report_change_product,
  report_return_product,
  report_return_claim,
  reports
};
